module.exports = __webpack_public_path__ + "img/zcsm.a907fe1a.png";